$.widget("custom.sidenav", {
    options: {
    },
    _create: function () {
        var $widget = this,
            $this = $widget.element;
        $("svg", $this).click(function () {
            var $this = $(this);
            $this.parent().toggleClass("expanded");
        });

    }
});
